import { render, staticRenderFns } from "./pests.vue?vue&type=template&id=146ebbc7&scoped=true&"
import script from "./pests.vue?vue&type=script&lang=js&"
export * from "./pests.vue?vue&type=script&lang=js&"
import style0 from "./pests.vue?vue&type=style&index=0&id=146ebbc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146ebbc7",
  null
  
)

export default component.exports